/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate random numbers in any range, or version-4 UUIDs in bulk. Choose your options and copy the results — everything runs in your browser.`)
};

const es_rg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera números aleatorios en cualquier rango, o UUID de versión 4 en masa. Elige tus opciones y copia los resultados — todo se ejecuta en tu navegador.`)
};

const de_rg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generiere Zufallszahlen in jedem Bereich oder Version-4-UUIDs in großen Mengen. Wähle deine Optionen und kopiere die Ergebnisse — alles läuft in deinem Browser.`)
};

const nl_rg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer willekeurige getallen in elk bereik, of versie-4 UUIDs in bulk. Kies uw opties en kopieer de resultaten — alles draait in uw browser.`)
};

const fr_rg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générez des nombres aléatoires dans n'importe quelle plage, ou des UUID version 4 en masse. Choisissez vos options et copiez les résultats — tout s'exécute dans votre navigateur.`)
};

const it_rg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera numeri casuali in qualsiasi intervallo, o UUID version-4 in massa. Scegli le tue opzioni e copia i risultati — tutto viene eseguito nel tuo browser.`)
};

const pt_br2_rg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere números aleatórios em qualquer intervalo ou UUIDs versão 4 em massa. Escolha suas opções e copie os resultados — tudo funciona no seu navegador.`)
};

const pt_rg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere números aleatórios em qualquer intervalo, ou UUIDs de versão-4 em massa. Escolha as suas opções e copie os resultados — tudo funciona no seu navegador.`)
};

const ja_rg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意の範囲でランダム番号を生成するか、バージョン4のUUIDを一括生成します。オプションを選択して結果をコピーします。すべてブラウザで実行されます。`)
};

const zh_rg_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在任意范围内生成随机数，或批量生成第4版UUID。设置好选项后复制结果——一切都在浏览器中完成。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_intro", locale)
	if (locale === "en") return en_rg_intro(inputs)
	if (locale === "es") return es_rg_intro(inputs)
	if (locale === "de") return de_rg_intro(inputs)
	if (locale === "nl") return nl_rg_intro(inputs)
	if (locale === "fr") return fr_rg_intro(inputs)
	if (locale === "it") return it_rg_intro(inputs)
	if (locale === "pt-BR") return pt_br2_rg_intro(inputs)
	if (locale === "pt") return pt_rg_intro(inputs)
	if (locale === "ja") return ja_rg_intro(inputs)
	return zh_rg_intro(inputs)
};